import * as Styled from './styles';
import { FullscreenIcon } from 'icons/FullscreenIcon';

type Props = {
  onOpenOriginal: () => void;
};

export const OpenOriginalButton = ({ onOpenOriginal }: Props) => {
  return (
    <Styled.NftMediaIconWrapper
      type="secondary"
      onClick={() => {
        onOpenOriginal();
      }}
    >
      <FullscreenIcon />
    </Styled.NftMediaIconWrapper>
  );
};
